import React from 'react';
import {faChevronRight} from '@fortawesome/pro-regular-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faMessagesQuestion } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from '../../components/ui/Link';

const FAQSection: React.FC = () => (
    <div className="flex flex-col gap-6">
      <div className="flex items-center sm:gap-4 gap-[12px] h-10 lg:gap-2  md:ml-0">
        <FontAwesomeIcon
          icon={faMessagesQuestion as IconProp}
          color={"#4EADF1"}
          fontSize={'24'}
        />
        <h1
          className="font-bold font-avantgarde text-[16px] sm:text-[22px] leading-[24px]
        sm:leading-[33px] text-blue-900 "
        >
          Veelgestelde vragen
        </h1>
      </div>
      <p
        className="font-roboto sm:text-[18px] text-[15px]
        font-medium text-stone-800 sm:leading-[29.7px] leading-[24.7px]
       "
      >
        Hier lees je alvast de vijf meestgestelde vragen.
      </p>

      <span
        className="font-roboto font-normal
          sm:text-[16px] text-stone-800 sm:leading-[26.4px]
          text-[14px] leading-[23.1px]
         "
      >
        Heb je nog een andere vraag? Bekijk ze dan allemaal via de onderstaande
        button
      </span>
      <div>
        <Link
          variant="primary"
          href={`/home/faqoverzicht`}
        >
          Bekijk alle veelgestelde vragen
          <FontAwesomeIcon icon={faChevronRight as IconProp} />
        </Link>
      </div>
    </div>
  );

export default FAQSection;
